import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/profile/pages/employees/RootPage'))
const ProtectedTerminatePage = React.lazy(
  () => import('modules/employees/pages/ProtectedTerminatePage')
)

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: '',
      element: <RootPage />,
      children: [
        {
          path: navigation.employees.id.terminate.path,
          element: <ProtectedTerminatePage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
